<script setup lang="ts">
import type { KbdProps, KbdSlots } from "./kbd.types";
import { useKbd } from "./useKbd";

defineOptions({ name: "EKbd", inheritAttrs: false });

const props = withDefaults(defineProps<KbdProps>(), {
  as: "kbd",
  color: "neutral",
  variant: "subtle",
  size: "md",
});

defineSlots<KbdSlots>();

const { classes, resolvedKey, iconName, shouldShowIcon } = useKbd({ props });
</script>

<template>
  <e-primitive :as="props.as" :inner-class="classes" class="e-kbd" exportparts="base" v-bind="$attrs">
    <slot>
      <e-icon v-if="shouldShowIcon && iconName" exportparts="base:icon" :name="iconName" />
      <template v-else>
        {{ resolvedKey }}
      </template>
    </slot>
  </e-primitive>
</template>

<style>
:host {
  display: contents;
}
</style>
